import axios from 'axios';
import React, { useEffect, useState, useMemo } from 'react'
import { useForm } from 'react-hook-form';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form } from 'reactstrap';
import { Label } from 'reactstrap'
import { Phone } from 'react-telephone';
import ErrorComponents from '../errorComponents/ErrorComponents';
import { useDispatch } from 'react-redux';
import { environment, S3_BUCKET, myBucket, BuildingLink } from './../../env';
import { getLotIntentAction, loaderAction, successModalToggle } from '../../redux/actions/Index';
import SuccessPopups from './../Popups/SuccessPopups';
import { PencilLine } from '@phosphor-icons/react';

function LetterIntentModal(props) {
    const [modal, setModal] = useState(false);
    const [contact, setContact] = useState();
    const [checked, setChecked] = useState();
    const [btndis, setBtndis] = useState(false);
    const [auto, setAuto] = useState(true);
    const [fax, setFax] = useState();
    const [img, setImg] = useState();
    const [imgerr, setimgerr] = useState();
    const [contecterr, setContecterr] = useState(false);
    const preventNegativeValues = (e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
    const toggle = () => { setModal(!modal) };
    const [faxNumber, setfaxNumber] = useState('');
    const [phoneNumber, setphoneNumber] = useState('');
    const {
        register,
        handleSubmit,
        reset,
        watch,
        setValue,
        formState: { errors },
    } = useForm({ mode: "onChange" });

    const dispatch = useDispatch()

    const createLOT = async (data) => {
        var date = Math.round(+new Date() / 1000);
        const params = {
            ACL: "public-read",
            Body: data[0],
            Bucket: S3_BUCKET,
            Key: `${date}_${data[0].name}`,
        };
        myBucket.upload(params, function (err, uploadData) {
            if (uploadData) {
                data = uploadData.Location;
                return (data);
            } else {
                console.log("error", err);
            }
        });
    }

    const getLotIntent = () => {
        try {
            axios.get(`${environment.baseUrl}checked-intent/`).then(res => {
                props.update(!props.updat)
                dispatch(getLotIntentAction(res.data));
            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };
    const onSubmit = async (data) => {
        var date = Math.round(+new Date() / 1000);
        setBtndis(true);
        dispatch(loaderAction(true))
        if (data.contact_number.length !== 13) {
            data.contact_number
            setContecterr(true)
            setBtndis(false)
            return;
        }
        const LOTpayload = new FormData();
        if (data?.company_logo?.length != 0) {
            LOTpayload.append("company_logo", `${BuildingLink}${date}_${data.company_logo[0].name}`);
            await createLOT(data.company_logo)
        }
        LOTpayload.append("register_address", data?.register_address);
        LOTpayload.append("contact_number", data?.contact_number);
        LOTpayload.append("corporate_office", data?.corporate_office);
        LOTpayload.append("fax_number", data?.fax_number);
        LOTpayload.append("website_url", data?.website_url);
        LOTpayload.append("name_of_company", data?.name_of_company);
        LOTpayload.append("company_address", data?.company_address);
        LOTpayload.append("on_use", false);
        try {
            await axios
                .post(`${environment.baseUrl}intent-pdf/`, LOTpayload)
                .then((form) => {
                    if (form.data.code === 200) {
                        dispatch(successModalToggle());
                    }
                    reset();
                    setBtndis(false);
                    props.update(auto)
                    setAuto(!auto)
                    toggle();
                    setContact();
                    setFax();
                    dispatch(loaderAction(true))
                });

        } catch (err) {
            setBtndis(false);
            dispatch(loaderAction(false))
            console.log(err);
        }
    };

    const onEdit = async (data) => {
        setBtndis(true);
        dispatch(loaderAction(true))
        if (data.contact_number.length !== 13) {
            data.contact_number
            setContecterr(true)
            setBtndis(false)
            return;
        }
        const LOTpayload = new FormData();
        if (data?.company_logo?.length != 0) {
            var date = Math.round(+new Date() / 1000);
            LOTpayload.append("company_logo", `${BuildingLink}${date}_${data.company_logo[0].name}`);
            await createLOT(data.company_logo)
        }
        LOTpayload.append("register_address", data?.register_address ? data?.register_address : ' ');
        LOTpayload.append("contact_number", data?.contact_number);
        LOTpayload.append("corporate_office", data?.corporate_office ? data?.corporate_office : ' ');
        LOTpayload.append("fax_number", data?.fax_number ? data?.fax_number : ' ');
        LOTpayload.append("website_url", data?.website_url ? data?.website_url : ' ');
        LOTpayload.append("name_of_company", data?.name_of_company);
        LOTpayload.append("company_address", data?.company_address ? data?.company_address : ' ');
        LOTpayload.append("on_use", checked);
        try {
            await axios
                .put(`${environment.baseUrl}edit-intent-pdf/${props?.data?.id}`, LOTpayload)
                .then((form) => {
                    if (form.data.code === 200) {
                        dispatch(successModalToggle());
                    }
                    reset();
                    setBtndis(false);
                    getLotIntent();
                    setContact();
                    setFax();
                    toggle();
                    dispatch(loaderAction(true))
                });

        } catch (err) {
            setBtndis(false);
            dispatch(loaderAction(false))
            console.log(err);
        }
    };

    const CancelButton = () => {
        toggle();
        reset()
    }



    useEffect(() => {
        reset({
            "register_address": props?.data?.register_address,
            "corporate_office": props?.data?.corporate_office,
            "website_url": props?.data?.website_url,
            "contact_number": props?.data?.contact_number.slice(3, 13),
            "fax_number": props?.data?.fax_number,
            "name_of_company": props?.data?.name_of_company,
            "company_address": props?.data?.company_address,
            "on_use": props?.data?.on_use,
        })
        console.log("----------------", props?.data?.contact_number);
        setChecked(props?.data?.on_use)
        setphoneNumber(props?.data?.contact_number)
        setfaxNumber(props?.data?.fax_number)
    }, [props?.data, modal])

    return (
        <>
            <div className='LOTmain'>
                {props.button == "create" ?
                    <Button onClick={toggle} className='border-radius-7  d-flex align-items-center buttons  py-3 px-2 py-md-3 py-lg-4 py-xl-4  px-md-4 px-lg-5 px-xl-5center buttons py-4'><span className='fs-3 d-flex gap-3 title-font-600 ps-3 pe-2'>Add Intent</span></Button>
                    : (
                        <button
                            onClick={() => { toggle(); }}
                            className="icon-bg-yellow border-0 px-2 py-3 rounded"><PencilLine size="28" className='icon-color-yellow' /></button>
                    )}
                <Modal className='border-0' isOpen={modal} toggle={props.toggle} size="lg" centered>
                    <ModalHeader className='bg-base-color ' ><span className='title-font-700 fs-36 text-base-white'>Letter Of Intent</span></ModalHeader>
                    <Form onSubmit={props.button == 'create' ?
                        handleSubmit(onSubmit) :
                        handleSubmit(onEdit)}>
                        <ModalBody className='bg-background-color px-5'>
                            <div className="row">
                                <div className="col-11 mx-auto col-md-6 col-lg-6 col-xl-6 pb-3 pt-1  mx-md-0">
                                    <Label className="fs-4 title-font-500 mb-0 text-base-color form-label">
                                        Company Logo *
                                    </Label>
                                    <br />
                                    <div className="mt-1 d-flex gap-3">
                                        <input
                                            className="border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input bg-white"
                                            type="file"
                                            placeholder="Upload Images..."
                                            {...register("company_logo", props.button == 'create' && { required: true })}
                                        />
                                    </div>
                                    <br />
                                </div>
                                {errors.company_logo && <ErrorComponents error={'Company Logo is required *'} />}
                                {imgerr && <ErrorComponents error={imgerr} />}
                                <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6 pb-3 pt-1  mx-md-0'>
                                    <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                        Company Name *
                                    </Label>
                                    <br />
                                    <div className='mt-1  d-flex gap-3'>
                                        <input
                                            className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                            type='text'
                                            minLength={0}
                                            maxLength={100}
                                            placeholder='Enter Company Name...'
                                            {...register("name_of_company", { required: true })}
                                        />
                                    </div>

                                    {errors.name_of_company && <ErrorComponents error={'Company Name is required *'} />}
                                    <br />
                                </div>
                                <div className="col-11 mx-auto col-md-6 col-lg-6 col-xl-6 pb-3 pt-1  mx-md-0">
                                    <Label className="fs-4 title-font-500 mb-0 text-base-color form-label">
                                        Contact Number *
                                    </Label>
                                    <br />
                                    <div className='mt-1  d-flex gap-3'>
                                        <   Phone {...register('contact_number')}
                                            value={phoneNumber}
                                            defaultCountry="in" className='d-flex border-radius-10 shadow-none px-4  w-100 fs-4 title-font-500 fs-2 modal-input bg-white py-3'>
                                            <Phone.Country className='fs-4 border-0 w-35 border-end' />
                                            <Phone.Number placeholder="1234567890" className=' ps-2 w-75 fs-4 title-font-500 border-0' />
                                        </Phone>
                                    </div>
                                    {contecterr && <ErrorComponents error={'Enter Contact Number'} />}
                                    <br />
                                </div>
                                <div className="col-11 mx-auto col-md-6 col-lg-6 col-xl-6 pb-3 pt-1  mx-md-0">
                                    <Label className="fs-4 title-font-500 mb-0 text-base-color form-label">
                                        Fax Number
                                    </Label>
                                    <br />
                                    <div className='mt-1  d-flex gap-3'>
                                        <Phone {...register('fax_number')} value={faxNumber}
                                            defaultCountry="in" className='d-flex border-radius-10 shadow-none px-4  w-100 fs-4 title-font-500 fs-2 modal-input bg-white py-3'>
                                            <Phone.Country className='fs-4 border-0 w-35 border-end' />
                                            <Phone.Number placeholder="1234567890" className=' ps-2 w-75 fs-4 title-font-500  border-0' />
                                        </Phone>
                                    </div>
                                    {/* {contecterr && <ErrorComponents error={'Enter Contact Number'} />} */}
                                    <br />
                                </div>
                                <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6 pb-3 pt-1  mx-md-0'>
                                    <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                        Company  Address
                                    </Label>
                                    <br />
                                    <div className='mt-1  d-flex gap-3'>
                                        <textarea
                                            className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                            minLength={0}
                                            placeholder='Enter Company Address...'
                                            {...register("company_address")}
                                        ></textarea>
                                    </div>
                                    {errors.company_address && <ErrorComponents error={'Company Address is required *'} />}
                                    <br />
                                </div>
                                <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6 pb-3 pt-1  mx-md-0'>
                                    <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                        Website Url
                                    </Label>
                                    <br />
                                    <div className='mt-1  d-flex gap-3'>
                                        <input
                                            className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input text-lowercase'
                                            type='text'
                                            placeholder='www.sumeetlogistics.com'
                                            {...register("website_url", {
                                                // pattern: {
                                                //     value: /^(www.)[a-zA-Z0-9_.-]+(\.[a-zA-Z]{2,3})$/,
                                                //     message: "Enter valid website url"
                                                // }
                                            })}
                                        />
                                    </div>
                                    {errors.website_url && <ErrorComponents error={errors.website_url.message} />}
                                    <br />
                                </div>
                                <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6 pb-3 pt-1  mx-md-0'>
                                    <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                        Register Address
                                    </Label>
                                    <br />
                                    <div className='mt-1  d-flex gap-3'>
                                        <textarea
                                            className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                            placeholder='Enter Register Address...'
                                            {...register("register_address")}
                                        ></textarea>
                                    </div>
                                    {/* {errors.register_address && <ErrorComponents error={'Register Address is required *'} />} */}
                                    <br />
                                </div>
                                <div className='col-11 mx-auto col-md-6 col-lg-6 col-xl-6 pb-3 pt-1  mx-md-0'>
                                    <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                        Corporate Office
                                    </Label>
                                    <br />
                                    <div className='mt-1  d-flex gap-3'>
                                        <textarea
                                            className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                                            placeholder='Enter Corporate Office...'
                                            {...register("corporate_office")}
                                        ></textarea>
                                    </div>
                                    {errors.corporate_office && <ErrorComponents error={'Corporate Office is required*'} />}
                                    <br />
                                </div>
                            </div>
                            {props.button != 'create' &&
                                <div className="d-flex align-items-center mt-2 gap-2">
                                    <input
                                        type="checkbox"
                                        id="on_use"
                                        name="on_use"
                                        checked={checked}
                                        className='checkinclusive'
                                        {...register("on_use", { onChange: e => setChecked(e.target.checked) })}
                                    />
                                    <Label className='fs-3 title-font-700 mb-0 text-base-color' htmlFor='on_use'>
                                        Do you want to use this Details?
                                    </Label>
                                </div>
                            }
                        </ModalBody>
                        <ModalFooter>
                            <Button type='button' className='border-radius-7 p-3 d-flex align-items-center buttons-outline' onClick={CancelButton}><span className='fs-4 d-flex gap-3 title-font-600 px-3'>Cancel</span></Button>{' '}
                            <Button className='border-radius-7 p-3 d-flex align-items-center buttons' disabled={btndis}><span className='fs-4 d-flex gap-3 title-font-600 px-3'>{props.button == "create" ? "Create" : "Save"}</span></Button>
                        </ModalFooter>
                    </Form>
                </Modal>
            </div>
        </>
    )
};


export default LetterIntentModal